import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { portinColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPortin } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "plan_id",
  "trial_count",
  "zipcode",
  "msisdn",
  "last_updated",
];

const SelectelPortinBatch = () => (
  <BatchDetail
    title="Portin"
    apiGet={__getPortin}
    client={CLIENTS.selectel}
    columnsFactory={portinColumns}
    copyKeys={COPY_KEYS}
    exportAction="portin"
    showTerminate
    getRowPath={(row) => `/selectel/portin/${row.id}`}
  />
);

export default SelectelPortinBatch;
